import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";

const STATUS_COLORS = { pending: "warning", sent: "success", failed: "error" };

const columns = [
  { id: "scheduledFor", label: "Scheduled For", minWidth: 160 },
  { id: "notificationType", label: "Title", minWidth: 130 },
  { id: "notificationText", label: "Body", minWidth: 200 },
  { id: "userCount", label: "Users", minWidth: 60, align: "center" },
  { id: "status", label: "Status", minWidth: 100 },
  { id: "actions", label: "Actions", minWidth: 80, align: "center" },
];

export default function ScheduledNotificationsTable({ scheduledNotifications, onDelete }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  return (
    <div style={{ marginTop: "40px" }}>
      <h2 style={{ fontSize: "20px", fontWeight: 700, marginBottom: "12px", color: "white" }}>
        📅 Scheduled Notifications
      </h2>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="scheduled notifications">
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell
                    key={col.id}
                    align={col.align || "left"}
                    style={{ minWidth: col.minWidth, fontWeight: 700, backgroundColor: "#f3f4f6" }}
                  >
                    {col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {scheduledNotifications.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" style={{ color: "#9ca3af", padding: "28px" }}>
                    No scheduled notifications
                  </TableCell>
                </TableRow>
              ) : (
                scheduledNotifications
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell>{row.scheduledFor}</TableCell>
                      <TableCell>{row.notificationType}</TableCell>
                      <TableCell
                        style={{
                          maxWidth: 260,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={row.notificationText}
                      >
                        {row.notificationText}
                      </TableCell>
                      <TableCell align="center">{row.userCount}</TableCell>
                      <TableCell>
                        <Chip
                          label={row.status}
                          color={STATUS_COLORS[row.status] || "default"}
                          size="small"
                          sx={{ textTransform: "capitalize", fontWeight: 600 }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {row.status === "pending" && (
                          <Tooltip title="Cancel scheduled notification">
                            <IconButton size="small" color="error" onClick={() => onDelete(row.id)}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={scheduledNotifications.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(_, p) => setPage(p)}
          onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }}
          sx={{
            "& .MuiTablePagination-selectLabel": { marginBottom: 0 },
            "& .MuiTablePagination-displayedRows": { marginBottom: 0 },
          }}
        />
      </Paper>
    </div>
  );
}
